import { FeatureSwitches } from "../containers/Storefront";

export const safeFeature = (fs: FeatureSwitches | undefined, feature: string, defaultValue: boolean = false) => ((fs && fs[feature]) || defaultValue)